'use client';

import { type LanguageCode, isLanguageCode } from '@ifixit/i18n/languages';
import { useSyncExternalStore } from 'react';

/**
 * Returns the best matching supported language code from the browser's
 * language preferences (`navigator.languages`). Tries exact match first,
 * then language-prefix match. Returns null if no match is found.
 */
export function useBrowserLanguage(): LanguageCode | null {
   return useSyncExternalStore(emptySubscribe, getBrowserLanguage, () => null);
}

function emptySubscribe() {
   return () => {};
}

function getBrowserLanguage(): LanguageCode | null {
   for (const browserLang of navigator.languages) {
      const normalized = browserLang.toLowerCase();
      if (isLanguageCode(normalized)) {
         return normalized;
      }

      const prefix = normalized.split('-')[0];
      if (isLanguageCode(prefix)) {
         return prefix;
      }
   }
   return null;
}
